var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classes},[_vm._v("\n    "+_vm._s(_vm.data[_vm.labelName])+"\n    "),(_vm.showArrow)?_c('Icon',{attrs:{"type":"ios-arrow-forward"}}):_vm._e(),_vm._v(" "),(_vm.showLoading)?_c('Icon',{class:_vm.showLoadingClasses,attrs:{"type":"ios-loading"}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/cascader/casitem.vue